import axios from "axios";

export default axios.create({
  baseURL: "https://gestion-interna.astrolinevs.com",
  headers: {
    "Content-type": "application/json",
  },
});
